import { requiredMessage } from "../../../../../utils";

export const renderRequiredData = (isRequired: boolean): string | boolean => {
    return isRequired ? requiredMessage : false;
};

export const booleanValidation = (isRequired: boolean, value: any): boolean => {
    return !isRequired || (value !== undefined && typeof value == "boolean");
};
